'use strict';

module.exports = angular.module('ui.utils.masks', [
	require('./global/global-masks'),
	require('./br/br-masks'),
	require('./ch/ch-masks'),
	require('./fr/fr-masks'),
	require('./us/us-masks')
]).name;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-input-masks/src/angular-input-masks.js
 ** module id = 308
 ** module chunks = 1
 **/